import Academic from "./Academic";

class PaymentStatusPoller {
    constructor(config = {}) {
        this.statusUrl = config.statusUrl || '';
        this.pollDelay = Number(config.pollDelay) > 0 ? Number(config.pollDelay) : 5000;
        this.buildRequestData = typeof config.buildRequestData === 'function'
            ? config.buildRequestData
            : ((invoiceId) => ({ invoice_no: invoiceId }));
        this.getStatusValue = typeof config.getStatusValue === 'function'
            ? config.getStatusValue
            : ((response) => response && typeof response === 'object' ? response.status : response);
        this.successValues = Array.isArray(config.successValues) && config.successValues.length
            ? config.successValues
            : [true, 'SUCCESS'];
        this.isSuccess = typeof config.isSuccess === 'function' ? config.isSuccess : null;
        this.onSuccess = typeof config.onSuccess === 'function' ? config.onSuccess : () => {};
        this.onError = typeof config.onError === 'function' ? config.onError : () => {};
        this.onResponse = typeof config.onResponse === 'function' ? config.onResponse : () => {};

        this.timer = null;
        this.cancelSource = null;
        this.invoiceId = '';
        this.isPolling = false;
    }
    
    normalizeStatusValue(value) {
        return typeof value === 'string' ? value.toUpperCase() : value;
    }

    isSuccessfulResponse(response) {
        if (this.isSuccess) {
            return this.isSuccess(response);
        }

        const currentStatus = this.normalizeStatusValue(this.getStatusValue(response));
        return this.successValues.some((successValue) => {
            return currentStatus === this.normalizeStatusValue(successValue);
        });
    }

    buildUrl(invoiceId) {
        const url = new URL(this.statusUrl, window.location.origin);
        const requestData = this.buildRequestData(invoiceId) || {};

        Object.keys(requestData).forEach((key) => {
            const value = requestData[key];
            if (value === undefined || value === null || value === '') {
                return;
            }

            url.searchParams.set(key, value);
        });

        return url.toString();
    }

    stop() {
        if (this.timer) {
            clearTimeout(this.timer);
            this.timer = null;
        }

        if (this.cancelSource) {
            this.cancelSource.cancel('Payment polling stopped.');
            this.cancelSource = null;
        }

        this.invoiceId = '';
        this.isPolling = false;
    }

    schedule() {
        if (!this.invoiceId) {
            return;
        }

        this.timer = setTimeout(() => {
            this.poll();
        }, this.pollDelay);
    }

    async poll() {
        if (!this.invoiceId || this.isPolling || !this.statusUrl) {
            return;
        }

        this.isPolling = true;
        this.cancelSource = window.axios && window.axios.CancelToken
            ? window.axios.CancelToken.source()
            : null;

        try {
            let data = null;

            if (window.axios) {
                const response = await window.axios.get(this.statusUrl, {
                    params: this.buildRequestData(this.invoiceId) || {},
                    cancelToken: this.cancelSource ? this.cancelSource.token : undefined,
                    headers: {
                        'Accept': 'application/json',
                        'X-Requested-With': 'XMLHttpRequest',
                    },
                });

                data = response.data;
            } else {
                const response = await fetch(this.buildUrl(this.invoiceId), {
                    method: 'GET',
                    headers: {
                        'Accept': 'application/json',
                        'X-Requested-With': 'XMLHttpRequest',
                    },
                    credentials: 'same-origin',
                });

                data = await response.json();
            }

            this.onResponse(data);

            if (this.isSuccessfulResponse(data)) {
                this.stop();
                this.onSuccess(data);
                return;
            }

            this.schedule();
        } catch (error) {
            if (
                (window.axios && typeof window.axios.isCancel === 'function' && window.axios.isCancel(error)) ||
                (error && error.name === 'AbortError')
            ) {
                return;
            }

            this.onError(error);
            this.schedule();
        } finally {
            this.isPolling = false;
            this.cancelSource = null;
        }
    }

    start(invoiceId, options = {}) {
        this.stop();

        if (!invoiceId) {
            return;
        }

        this.invoiceId = invoiceId;
        const shouldPollImmediately = options.immediate !== false;

        if (shouldPollImmediately) {
            this.poll();
            return;
        }

        this.schedule();
    }
}

export default class Generic {
    static createPaymentStatusPoller(config = {}) {
        return new PaymentStatusPoller(config);
    }

    /**
     * academic related codes
     */
    static initFilter() {
        //filter by org_id
        if(window.filter_org){
            $('select[name="org_id"]').on('change', function () {
                let org_id = $(this).val();
                let getUrl = window.location.href.split('?')[0];
                if(org_id){
                    getUrl +="?org_id="+org_id;

                }
                window.location = getUrl;

            });
        }
        $('select[name="class_id"]').on('change', function () {
            if($('select[name="subject_id"]').length){
                $('select[name="subject_id"]').empty().select2({placeholder: 'Pick a subject...'});
            }
            if($('select[name="fourth_subject"]').length){
                $('select[name="fourth_subject"]').empty().select2({placeholder: 'Pick a subject...'});
            }
        });
        $('select[name="section_id"]').on('change', function () {
            //hide button
            let sectionId = $(this).val();
            let classId =  $('select[name="class_id"]').val();

            //validate input
            if(!classId || !sectionId){
                return false;
            }

            Generic.loaderStart();

            if($('select[name="subject_id"]').length){
                getSubject(classId, window.subjectType , sectionId,function (res={}) {
                    // console.log(res);
                    if (Object.keys(res).length){
                        $('select[name="subject_id"]').empty().prepend('<option selected=""></option>').select2({placeholder: 'Pick a subject...', data: res});
                    }
                    else{
                        // clear subject list dropdown
                        $('select[name="subject_id"]').empty().select2({placeholder: 'Pick a subject...'});
                        toastr.warning('This class have no subject!');
                    }
                    Generic.loaderStop();
                });
            }
            if($('select[name="fourth_subject"]').length){
                getSubject(classId, window.subjectType , sectionId,function (res={}) {
                    // console.log(res);
                    if (Object.keys(res).length){
                        $('select[name="fourth_subject"]').empty().prepend('<option selected=""></option>').select2({placeholder: 'Pick a subject...', data: res});
                    }
                    else{
                        // clear subject list dropdown
                        $('select[name="fourth_subject"]').empty().select2({placeholder: 'Pick a subject...'});
                        toastr.warning('This class have no subject!');
                    }
                    Generic.loaderStop();
                });
            }
            // Academic.checkAttendanceExists(function (data) {
            //     if(data>0){
            //         toastr.error('Attendance already exists!');
            //     }
            //
            //     Generic.loaderStop();
            //
            // });


        });
        function  getSubject(class_id, $type=0,$section=0, cb) {
            let getUrl = window.subject_list_url + "?class=" + class_id+"&type="+$type+"&section="+$section;
            if (class_id) {
                axios.get(getUrl)
                    .then((response) => {
                        cb(response.data);

                    }).catch((error) => {
                    let status = error.response.statusText;
                    toastr.error(status);
                    cb();

                });
            }
            else {
                cb();
            }
        }
    }
    static initCommonPageJS() {
        $("#entryForm").validate({
            errorElement: "em",
            errorPlacement: function (error, element) {
                // Add the `help-block` class to the error element
                error.addClass("help-block");
                if (element.data('err')) {
                    $(element.data('err')).append(error);
                } else {
                    error.insertAfter(element);
                }

            },
            highlight: function (element, errorClass, validClass) {
                $(element).parents(".form-group").addClass("has-error").removeClass("has-success");
                $("#entryForm").find("button[type='submit']").removeAttr("disabled");
            },
            unhighlight: function (element, errorClass, validClass) {
                $(element).parents(".form-group").addClass("has-success").removeClass("has-error");
            },
            submitHandler: function (form) {
                $(form).find("button[type='submit']").attr("disabled", true);
                form.submit()
            }
        });
        $(".date_picker").datetimepicker({
            format: "DD/MM/YYYY",
            viewMode: 'days',
            ignoreReadonly: true,
        });
        $(".date_picker_with_clear").datetimepicker({
            format: "DD/MM/YYYY",
            viewMode: 'days',
            showClear: true,
            ignoreReadonly: true
        });


        $(".date_picker2").datetimepicker({
            format: "DD/MM/YYYY",
            viewMode: 'years',
            ignoreReadonly: true
        });

        $(".time_picker").datetimepicker({
            format: 'LT',
            showClear: true,
            ignoreReadonly: true
        });

        $(".date_time_picker").datetimepicker({
            format: "DD/MM/YYYY LT",
            viewMode: 'days',
            ignoreReadonly: true
        });

        $('.date_picker_with_disable_days').datetimepicker({
            format: "DD/MM/YYYY",
            viewMode: 'days',
            ignoreReadonly: true,
            daysOfWeekDisabled: window.disableWeekDays,
            useCurrent: false
        });

        $('.only_year_picker').datetimepicker({
            format: "YYYY",
            viewMode: 'years',
            ignoreReadonly: true,
            useCurrent: false
        });
        $('html .datatable-server').on('change', 'input.statusChange', function (e) {
            let that = $(this);
            if (stopchange === false) {
                let isActive = $(this).prop('checked') ? 1 : 0;
                let pk = $(this).attr('data-pk');
                let newpostUrl = postUrl.replace(/\.?0+$/, pk);
                axios.post(newpostUrl, { 'status': isActive })
                    .then((response) => {
                        if (response.data.success) {
                            toastr.success(response.data.message);
                        }
                        else {
                            let status = response.data.message;
                            if (stopchange === false) {
                                stopchange = true;
                                that.bootstrapToggle('toggle');
                                stopchange = false;
                            }
                            toastr.error(status);
                        }

                    }).catch((error) => {
                    // console.log(error.response);
                    let status = error.response.statusText;
                    if (stopchange === false) {
                        stopchange = true;
                        that.bootstrapToggle('toggle');
                        stopchange = false;
                    }
                    toastr.error(status);

                });
            }
        });
        // var buttonCommon = {
        //     exportOptions: {
        //         columns: ':not(.notexport)',
        //         format: {
        //             body: function (data, row, column, node) {
        //                 if(typeof(window.changeExportColumnIndex) !== 'undefined') {
        //                     var onValue = typeof window.changeExportColumnValue !== 'undefined' ? window.changeExportColumnValue[0] : 'Active';
        //                     var offValue = typeof window.changeExportColumnValue !== 'undefined' ? window.changeExportColumnValue[1] : 'Inactive';
        //                     if (column === window.changeExportColumnIndex) {
        //                         data = /checked/.test(data) ? onValue : offValue;
        //                     }
        //                 }
        //                 return data;
        //             }
        //         }
        //     }
        // };

        //table with out search
        var table = $('#listDataTable').DataTable({
            pageLength: 25,
            lengthChange: false,
            responsive: true,
            searching: false,
            // buttons: [
            //     $.extend(true, {}, buttonCommon, {
            //         extend: 'copy',
            //         text: '<i class="fa fa-files-o"></i>',
            //         titleAttr: 'copy',
            //     }),
            //     $.extend(true, {}, buttonCommon, {
            //         extend: 'csv',
            //         text: '<i class="fa fa-file-text-o"></i>',
            //         titleAttr: 'csv',
            //     }),
            //     $.extend(true, {}, buttonCommon, {
            //         extend: 'excel',
            //         text: '<i class="fa fa-file-excel-o"></i>',
            //         titleAttr: 'Excel',
            //     }),
            //     $.extend(true, {}, buttonCommon, {
            //         extend: 'pdf',
            //         text: '<i class="fa fa-file-pdf-o"></i>',
            //         titleAttr: 'pdf',
            //         customize: function (doc) {
            //             doc.content[1].table.widths = Array(doc.content[1].table.body[0].length + 1).join('*').split('');
            //             doc.content[1].alignment = "center";
            //         }
            //     }),
            //     $.extend(true, {}, buttonCommon, {
            //         extend: 'print',
            //         text: '<i class="fa fa-print"></i>',
            //         titleAttr: 'print',
            //     })
            // ]
        });
        // table.buttons().container().appendTo($('.col-sm-6:eq(0)', table.table().container()));

        //table custom
        var table33 = $('#listDataTableOnlyPrint').DataTable({
            lengthChange: false,
            responsive: true,
            paging: false,
            filter: false,
            // buttons: [
            //     $.extend(true, {}, buttonCommon, {
            //         extend: 'print',
            //         text: '<i class="fa fa-print"></i>',
            //         titleAttr: 'print',
            //     })
            // ]
        });
        // table33.buttons().container().appendTo($('.col-sm-6:eq(0)', table33.table().container()));


        //style table with search
        // Setup - add a text input to each footer cell
        // $('#listDataTableWithSearch thead tr').clone(true).appendTo( '#listDataTableWithSearch thead' );
        // $('#listDataTableWithSearch thead tr:eq(1) th').each( function (i) {
        //
        //     if(window.excludeFilterComlumns.indexOf(i) > -1) {
        //         $(this).html( '' );
        //         return;
        //     }
        //
        //     $(this).html( '<input type="text" placeholder="Search" />' );
        //     $( 'input', this ).on( 'keyup change', function () {
        //         if ( table2.column(i).search() !== this.value ) {
        //             table2
        //                 .column(i)
        //                 .search( this.value )
        //                 .draw();
        //         }
        //     } );
        // } );

        var table2 = $('#listDataTableWithSearch').DataTable({
            pageLength: 25,
            lengthChange: false,
            orderCellsTop: true,
            responsive: true,
            // buttons: [
            //     $.extend(true, {}, buttonCommon, {
            //         extend: 'copy',
            //         text: '<i class="fa fa-files-o"></i>',
            //         titleAttr: 'copy',
            //     }),
            //     $.extend(true, {}, buttonCommon, {
            //         extend: 'csv',
            //         text: '<i class="fa fa-file-text-o"></i>',
            //         titleAttr: 'csv',
            //     }),
            //     $.extend(true, {}, buttonCommon, {
            //         extend: 'excel',
            //         text: '<i class="fa fa-file-excel-o"></i>',
            //         titleAttr: 'Excel',
            //     }),
            //     $.extend(true, {}, buttonCommon, {
            //         extend: 'pdf',
            //         text: '<i class="fa fa-file-pdf-o"></i>',
            //         titleAttr: 'pdf',
            //         customize: function (doc) {
            //             doc.content[1].table.widths = Array(doc.content[1].table.body[0].length + 1).join('*').split('');
            //             doc.content[1].alignment = "center";
            //         }
            //     }),
            //     $.extend(true, {}, buttonCommon, {
            //         extend: 'print',
            //         text: '<i class="fa fa-print"></i>',
            //         titleAttr: 'print',
            //     })
            // ]
        });
        // table2.buttons().container().appendTo($('.col-sm-6:eq(0)', table2.table().container()));


        let stopchange = false;
        $('html #listDataTableWithSearch, html #listDataTable').on('change', 'input.statusChange', function (e) {
            let that = $(this);
            if (stopchange === false) {
                let isActive = $(this).prop('checked') ? 1 : 0;
                let pk = $(this).attr('data-pk');
                let newpostUrl = postUrl.replace(/\.?0+$/, pk);
                axios.post(newpostUrl, { 'status': isActive })
                    .then((response) => {
                        if (response.data.success) {
                            toastr.success(response.data.message);
                        }
                        else {
                            let status = response.data.message;
                            if (stopchange === false) {
                                stopchange = true;
                                that.bootstrapToggle('toggle');
                                stopchange = false;
                            }
                            toastr.error(status);
                        }
                    }).catch((error) => {
                        // console.log(error.response);
                        let status = error.response.statusText;
                        if (stopchange === false) {
                            stopchange = true;
                            that.bootstrapToggle('toggle');
                            stopchange = false;
                        }
                        toastr.error(status);

                    });
            }
        });

        $(".year_picker").datetimepicker({
            format: "YYYY",
            viewMode: 'years',
            ignoreReadonly: true
        });

        $('input').not('.dont-style').iCheck({
            checkboxClass: 'icheckbox_square-blue',
            radioClass: 'iradio_square-blue',
            increaseArea: '20%' /* optional */
        });


    }

    static initDeleteDialog() {
        $('html #listDataTableWithSearch, html #listDataTable, html #listDataTableOnlyPrint').on('submit', 'form.myAction', function (e) {
            e.preventDefault();
            var that = this;
            swal({
                title: 'Are you sure?',
                text: 'You will not be able to recover this record!',
                type: 'warning',
                showCancelButton: true,
                confirmButtonColor: '#dd4848',
                cancelButtonColor: '#8f8f8f',
                confirmButtonText: 'Yes, delete it!',
                cancelButtonText: 'No, keep it'
            }).then((result) => {
                if (result.value) {
                    that.submit();
                }
            });
        });
    }

    static initMarksheetPublic() {
        Generic.initCommonPageJS();
        // $('#class_change').val('').trigger('change');
        $('#class_change').on('change', function () {
            let class_id = $(this).val();
            if(class_id) {
                //get sections
                Academic.getExam(class_id);
            }
            else{
                $('select[name="exam_id"]').empty().select2({placeholder: 'Pick a exam...'});
            }

        });
    }
    static loaderStart(){
        // console.log('loader started...');
        $('.ajax-loader').css('display','block');
    }
    static loaderStop(){
        // console.log('loader stoped...');
        $('.ajax-loader').css('display','none');
    }

    static initDropZone(
        selector,
        selector_of_value,
        uploadedPhotoPath,
        csrf_token
    ) {
        
        Dropzone.autoDiscover = false;
        
        const previewImage = $('#crop-image');
        const cropModal = $("#cropModal");
        let cropper = null;
        let currentFile = null;
        
        var photoDropzone = new Dropzone(selector, {
            url: "/upload",
            method: "POST",
            uploadMultiple: false,
            maxFiles: 1,
            maxFilesize: 20,
            acceptedFiles: ".jpg, .jpeg, .png",
            addRemoveLinks: false,
            autoProcessQueue: true,
            dictDefaultMessage: `
                <div id="dropzone-message" class="wrap-btn-d-upload">
                    <span class="mdi mdi-cloud-upload-outline icon-upload"></span><br>
                    <span class="dragDropText">Drag & Drop photo here</span>
                </div>
                <div class="or-upload">OR</div>
                <div class="btn-d-upload">Browse Photo</div>
                <p class="custom-text">JPG, JPEG, or PNG (Max size: 2MB)</p>
            `,
            dictInvalidFileType: "Only jpg, jpeg, png images are accepted.",
            dictFileTooBig: "The file is too big. Maximum allowed size: 2MB.",
            previewTemplate: document.querySelector("#template-container")?.innerHTML,
            headers: {
                'X-CSRF-TOKEN': csrf_token
            },
            init: function () {
                var myDropzone = this;
                photoDropzone = this;
                let storagePath = uploadedPhotoPath ? uploadedPhotoPath.split("/storage/")[1] : null;

                function checkViewUploadButton(selector) {
                    const dropzoneContainer = $(selector);
                    const dropzoneMessage = dropzoneContainer.find('.dz-default.dz-message');
                    const updateMessageClass = 'dz-update-message';

                    if (typeof myDropzone !== 'undefined' && myDropzone.files.length > 0) {
                        dropzoneMessage.addClass('d-none');

                        dropzoneContainer.find('.' + updateMessageClass).remove();

                        dropzoneContainer.find('.dz-preview:last').after(`
                            <div class="${updateMessageClass} text-center p-2" id="update-upload-container" style="cursor: pointer;">
                                <p class="text-primary m-0" id="update-upload-container" style="font-size: 14px; cursor: pointer;">Drop photo here for update</p>
                                <p id="update-upload-container" style="font-size: 12px; margin-top: 5px; cursor: pointer;">JPG, JPEG, or PNG (Max size: 2MB).</p>
                            </div>
                        `);

                        dropzoneContainer.addClass('files-uploaded');

                        $('#update-upload-container').on('click', function () {
                            myDropzone.hiddenFileInput.click();
                        });
                    } else {
                        dropzoneMessage.removeClass('d-none');
                        dropzoneContainer.removeClass('files-uploaded');
                        dropzoneContainer.find('.' + updateMessageClass).remove();
                    }
                }

                if (uploadedPhotoPath === "/storage/") {
                    uploadedPhotoPath = null;
                }

                var existingImagePath = $(selector_of_value).val();

                if (storagePath) {
                    $(selector_of_value).val(storagePath);
                }

               

                if (uploadedPhotoPath || existingImagePath) {
                    var imagePath = uploadedPhotoPath || existingImagePath;
                    var mockFile = {
                        name: "Existing Image",
                        size: 12345,
                        type: 'image/jpeg',
                        url: imagePath
                    };

                    myDropzone.emit("addedfile", mockFile);
                    myDropzone.emit("thumbnail", mockFile, imagePath);
                    myDropzone.emit("complete", mockFile);

                    mockFile.status = Dropzone.SUCCESS;
                    myDropzone.files.push(mockFile);

                    previewFile(mockFile);
                    checkViewUploadButton(selector);

                }

                // Show SweetAlert error when the file is invalid
                this.on("error", function (file, message) {
                    if (message === "File is too big") {
                        swal({
                            icon: 'error',
                            title: 'File Too Large',
                            text: 'The file you are trying to upload is too large. Please upload a file smaller than 2MB.',
                            confirmButtonText: 'OK'
                        }).then((result) => {
                            if (result.value) {
                                myDropzone.removeAllFiles();
                            }
                        });
                    } else if (typeof message === "object") {
                        // If the message is an object, try to display the error from the object
                        swal({
                            icon: 'error',
                            title: 'Upload Error',
                            text: message.error || 'Maximum allowed size in 2MB',
                            confirmButtonText: 'OK'
                        }).then((result) => {
                            if (result.value) {
                                myDropzone.removeAllFiles();
                            }
                        });
                    } else {
                        // For other types of errors
                        swal({
                            icon: 'error',
                            title: 'Oops...',
                            text: message || 'Something went wrong!',
                            confirmButtonText: 'OK'
                        }).then((result) => {
                            if (result.value) {
                                myDropzone.removeAllFiles();
                            }
                        });
                    }
                });

                // Prevent other files from being added to Dropzone
                this.on("addedfile", function (file) {
                    
                    if (!file.type.match(/image\/(jpeg|jpg|png)/)) {
                        this.removeFile(file);
                        swal({
                            icon: 'error',
                            title: 'Invalid File Type',
                            text: 'Only jpg, jpeg, png images are accepted.',
                            confirmButtonText: 'OK'
                        });
                    } else if (this.files.length > 1) {
                        this.removeFile(this.files[0]);
                    }
                    checkViewUploadButton(selector);
                    
                    
                    const reader = new FileReader();
                    reader.onload = function (event) {

                        $("#cropModal").data('img', event.target.result).modal('show');

                        const previewImage = document.getElementById('crop-image'); 
                        previewImage.onload = () => { 
                            
                            if (cropper) cropper.destroy();

                            
                            cropper = new Cropper(previewImage, {
                                aspectRatio: 1, 
                                viewMode: 1,
                                movable: true,
                                zoomable: true,
                                scalable: true,
                                cropBoxResizable: true 
                            });
                            
                            currentFile = file;
                        };

                        
                    };
                    reader.onerror = function (e) {
                    };
                    reader.readAsDataURL(file);
                    
                });

                this.on("uploadprogress", function (file, progress) {
                    const progressBar = file.previewElement.querySelector(".dz-upload");
                    if (progressBar) {
                        progressBar.style.width = progress + "%";
                    }
                });

                this.on("success", function (file, response) {
                    previewFile(file);
                    $(selector_of_value).val(response.filePath);
                    checkViewUploadButton(selector);
                });

                this.on("removedfile", function (file) {
                    file.previewElement.remove();
                    $(selector_of_value).val('');
                    setTimeout(() => {
                        checkViewUploadButton(selector);
                    }, 100);
                });

                this.error = function (file, message) {
                    if (file.previewElement) {
                        file.previewElement.classList.add("dz-error");
                        if (typeof message !== "string" && message.error) {
                            message = message.error;
                        }
                        for (let node of file.previewElement.querySelectorAll(
                            "[data-dz-errormessage]"
                        )) {
                            node.textContent = message;
                        }
                    }
                };
            }
        });
        $('#cropModal').on('shown.bs.modal', function () {
            let imageUrl = $(this).data('img');
            $('#crop-image').attr('src', imageUrl);
        });
        document.getElementById("crop-confirm").addEventListener("click", function () {
            cropper.getCroppedCanvas().toBlob(function (blob) {
                const croppedFile = new File([blob], currentFile.name, {
                    type: currentFile.type,
                    lastModified: Date.now()
                });
                photoDropzone.removeFile(currentFile); // remove original image
                photoDropzone.addFile(croppedFile);
                
                $("#cropModal").modal('hide');
            });
        });

        $(document).on('click', '#cropModal .btn-cancel', function () {
            if (photoDropzone.files.length > 0) {
                photoDropzone.removeFile(photoDropzone.files[0]);
            }
        });

        function previewFile(file) {
            var previewBox = null;

            if (file.url) {
                previewBox = document.createElement('img');
                previewBox.src = file.url;
                previewBox.style.maxWidth = "100%";

                file.previewElement.appendChild(previewBox);

                var removeIcon = file.previewElement.querySelector('.dz-remove');
                Generic.ensureDropzoneRemoveIcon(removeIcon);
                removeIcon.addEventListener('click', function () {
                    photoDropzone.removeFile(file);
                });
            } else {
                var reader = new FileReader();
                reader.onload = function (e) {
                    if (file.type && !file.type.startsWith('image')) {
                        previewBox = document.createElement('div');
                        previewBox.classList = 'text-center mt-5';
                        var spanICon = document.createElement('span');
                        spanICon.classList = "text-white mdi mdi-file-cog-outline fs-1";
                        previewBox.appendChild(spanICon);
                    } else {
                        previewBox = document.createElement('img');
                        previewBox.src = e.target.result;
                        previewBox.style.maxWidth = "100%";
                    }

                    file.previewElement.appendChild(previewBox);
                    var removeIcon = file.previewElement.querySelector('.dz-remove');
                    Generic.ensureDropzoneRemoveIcon(removeIcon);
                    removeIcon.addEventListener('click', function () {
                        photoDropzone.removeFile(file);
                    });
                };
                reader.readAsDataURL(file);
            }
        }
    }

    static invoicePortalPrint(
        selector,
        _filename_to_save
    ) {
        const content = document.getElementById(selector);
        const printWindow =  window.open('', 'Print-Window');
        const styles = Array.from(document.styleSheets)
            .filter(sheet => !sheet.disabled)
            .map(sheet => {
                try {
                    return Array.from(sheet.cssRules)
                        .map(rule => rule.cssText)
                        .join('');
                } catch (e) {
                    return '';
                }
            })
            .join('');
         const externalStyles = `
            <style>
                @font-face {
                    font-family: 'Roboto';
                    src: url('/fonts/Roboto-Regular.ttf') format('truetype');
                    font-weight: 400;
                    font-style: normal;
                }

                @font-face {
                    font-family: 'Siemreap';
                    src: url('/fonts/KhmerOSsiemreap.ttf') format('truetype');
                    font-weight: 400;
                    font-style: normal;
                }
                ${styles} 
                .print-area, .print-area * {
                    visibility: visible !important;
                    font-family: 'Roboto', 'Siemreap', sans-serif;
                    font-weight: 400;
                }
            </style>
        `;
        printWindow.open();
        printWindow.document.write(`
            <html>
                <head>
                    <title>Print Invoice</title>
                    ${externalStyles}
                </head>
                <body>
                    ${content.outerHTML}
                    <script>
                        window.onload = function() {
                            Promise.all([
                                document.fonts.load('1em Roboto'),
                                document.fonts.load('1em Siemreap')
                            ]).then(() => {
                                window.print();
                                window.onafterprint = () => window.close();
                            }).catch(() => {
                                // fallback: print anyway after some timeout
                                setTimeout(() => {
                                window.print();
                                window.onafterprint = () => window.close();
                                }, 500);
                            });
                        };
                    <\/script>
                </body>
            </html>
        `);
        printWindow.document.title = _filename_to_save
        printWindow.document.close();
    }

    static setColumnsSorted(_dataTable)
    {
        const selector = '#' + _dataTable;
        const table = $(selector).DataTable();
        const columns = table.settings().init().columns;
        if (!window.columns_sorted) {
            window.columns_sorted = {};
        }
        $(selector).on('order.dt', function () {
            window.columns_sorted[_dataTable] = {};
            const order = table.order();
            order.forEach(([index, dir]) => {
                const name = columns[index].name;
                if (name) {
                    window.columns_sorted[_dataTable][name] = dir;
                }
            });
        });
    }

    static getColumnsSorted(_dataTable) {
        return window.columns_sorted?.[_dataTable] || {};
    }

    static captureInvoice(_data, _method_call_back)
    {
        window.MobileBridge = new MobileBridge();
        window.MobileBridge.makePostData({ invoice_detail: _data }, _method_call_back);
    }

    static mediaUploader(_label, selector, selector_of_value, uploadedMediaPath, csrf_token, callback = null) {
        var photoDropzone = new Dropzone(selector,{
            url: "/media-upload",
            method: "POST",
            uploadMultiple: false,
            maxFiles: 1,
            maxFilesize: 20,
            acceptedFiles: null,
            addRemoveLinks: false,
            autoProcessQueue: true,
            maxThumbnailFilesize: 20,
            createImageThumbnails: false,
            acceptedFiles: "image/*,application/pdf,.doc,.docx,.xls,.xlsx",
            dictDefaultMessage: `
            <div id="dropzone-message" class="wrap-btn-d-upload">
                <span class="mdi mdi-cloud-upload-outline icon-upload"></span><br>
                <span class="dragDropText">Drag & Drop file here</span>
            </div>
            <div class="or-upload">OR</div>
            <div class="btn-d-upload">Browse File</div>
            <p class="custom-text">(Max size: 20MB)</p>
            ${_label}
            `,
            previewTemplate: document.querySelector("#template-container")?.innerHTML,
            headers: { 'X-CSRF-TOKEN': csrf_token },
            init: function () {
                const myDropzone = this;

                function checkViewUploadButton() {
                    const dropzoneContainer = $(selector);
                    const hasFiles = myDropzone.files.length > 0;
                    dropzoneContainer.find('.dz-default.dz-message')
                    .toggleClass('d-none', hasFiles);
                    dropzoneContainer
                    .toggleClass('files-uploaded', hasFiles)
                    .find('.dz-update-message').remove();

                    if (hasFiles) {
                    $('.dz-preview:last').after(`
                        <div class="dz-update-message text-center p-2" style="cursor:pointer;">
                        <p class="text-primary m-0" style="font-size:14px;">Drop file here to replace</p>
                        <p style="font-size:12px;margin-top:5px;">Max: 20MB</p>
                        ${_label}
                        </div>`);
                    $('#update-upload-container').on('click', () =>
                        myDropzone.hiddenFileInput.click()
                    );
                    }
                }

                let storagePath = uploadedMediaPath?.split("/storage/")[1] || null;
                let existing = storagePath || $(selector_of_value).val();

                if (existing) {
                    const mockFile = { name: "Existing File", size: 12345, type: "", url: existing };
                    myDropzone.emit("addedfile", mockFile);
                    myDropzone.emit("thumbnail", mockFile, existing);
                    myDropzone.emit("complete", mockFile);
                    mockFile.status = Dropzone.SUCCESS;
                    myDropzone.files.push(mockFile);
                    previewFile(mockFile);
                    $(selector_of_value).val(existing);
                    checkViewUploadButton();
                }

                this.on("addedfile", function (file) {
                    if (myDropzone.files.length > 1) {
                        myDropzone.removeFile(myDropzone.files[0]);
                    }
                    checkViewUploadButton();
                    previewFile(file);
                });

                this.on("success", function (file, resp) {
                    $(selector_of_value).val(resp.filePath);
                    checkViewUploadButton();
                    if (typeof callback === "function") {
                        callback('success', null);
                    }
                });

                this.on("removedfile", function (file) {
                    $(selector_of_value).val('');
                    checkViewUploadButton();
                });

                this.on("error", function (file, msg) {
                    const text = typeof msg === "object" ? (msg.error || msg.message) : msg;
                    swal({
                        icon: 'error',
                        title: 'Upload Error',
                        text: text || 'Something wrong!',
                        confirmButtonText: 'OK'
                    }).then(() => {
                        this.removeFile(file);
                        if (typeof callback === "function") {
                            callback(null, 'error');
                        }
                    });
                });
            }
        });

        function previewFile(file) {
            const ext = file.name.split('.').pop().toLowerCase();
            let previewBox;

            if (file.url) {
                previewBox = document.createElement('img');
                previewBox.src = file.url;
                previewBox.style.maxWidth = "100%";

            } else {
                const reader = new FileReader();
                reader.onload = function(e) {
                if (!file.type.startsWith('image')) {
                    previewBox = document.createElement('div');
                    previewBox.className = 'text-center mt-5';
                    const iconClassMap = { /* map from above */ };
                    const iconClass = iconClassMap[ext] || iconClassMap.default;
                    previewBox.innerHTML = `
                    <span class="text-white mdi ${iconClass} fs-1"></span>
                    <div class="ext-label">${ext.toUpperCase()}</div>
                    <span class="w-50 h-10"><i class="fas fa-file-alt"></i></span>`;
                } else {
                    previewBox = document.createElement('img');
                    previewBox.src = e.target.result;
                    previewBox.style.maxWidth = "100%";
                }
                attachPreview(previewBox, file);
                };
                reader.readAsDataURL(file);
                return;
            }

            attachPreview(previewBox, file);
        }

        function attachPreview(previewBox, file) {
            file.previewElement.appendChild(previewBox);
            const remove = file.previewElement.querySelector('.dz-remove');
            Generic.ensureDropzoneRemoveIcon(remove);
            remove.addEventListener('click', () => photoDropzone.removeFile(file));
        }

    }

    static ensureDropzoneRemoveIcon(removeElement) {
        if (!removeElement) {
            return;
        }

        const existingIcon = removeElement.querySelector('i');

        if (existingIcon) {
            existingIcon.className = 'fa fa-times-circle';
            return;
        }

        removeElement.innerHTML = '<i class="fa fa-times-circle"></i>';
    }

    static iniNavBarTab(_screen_with) {
        if ($('.nav.nav-tabs').length) {
            const $navTabs = $('.nav.nav-tabs');
            const $navLinks = $navTabs.find('.nav-link');

            const navTabsWidth = $navTabs.outerWidth();
            let totalLinksWidth = 0;

            $navLinks.each(function () {
                totalLinksWidth += $(this).outerWidth(true);
            });

            if (totalLinksWidth+5>navTabsWidth) {
                if (!$navTabs.parent().hasClass('scrollable-tabs')) {
                    $navTabs.wrap('<div class="scrollable-tabs"></div>');
                }
            }else {
                if ($navTabs.parent().hasClass('scrollable-tabs')) {
                    $navTabs.unwrap();
                }
            }

        }
    }
}
